const FONTS = [
  { name: "Playfair Display (actuelle)", family: '"Playfair Display", Georgia, serif', weight: 500 },
  { name: "Cormorant Garamond", family: '"Cormorant Garamond", Georgia, serif', weight: 500 },
  { name: "EB Garamond", family: '"EB Garamond", Georgia, serif', weight: 500 },
  { name: "Marcellus", family: "Marcellus, Georgia, serif", weight: 400 },
  { name: "Spectral", family: "Spectral, Georgia, serif", weight: 400 },
  { name: "Libre Baskerville", family: '"Libre Baskerville", Georgia, serif', weight: 400 },
  { name: "Lora", family: '"Lora", Georgia, serif', weight: 500 },
];

export default function TypoPreview() {
  return (
    <div className="mx-auto max-w-[1400px] px-5 pt-32 md:px-10 md:pt-40">
      <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-lagoon">
        Prévisualisation — choix de typographie
      </p>
      <div className="mt-10 border-t border-ink/10">
        {FONTS.map((f, i) => (
          <div key={f.name} className="border-b border-ink/10 py-10 md:py-14">
            <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/40">
              {String(i + 1).padStart(2, "0")} — {f.name}
            </p>
            <p
              style={{ fontFamily: f.family, fontWeight: f.weight }}
              className="text-5xl leading-none tracking-tight text-ink md:text-7xl"
            >
              Fafapiti <em className="text-lagoon">Lodge</em>
            </p>
            <p
              style={{ fontFamily: f.family, fontWeight: 400 }}
              className="mt-2 text-2xl italic text-ink/60 md:text-3xl"
            >
              — Fakarava
            </p>
          </div>
        ))}
      </div>
      <div className="h-24" />
    </div>
  );
}
